module.exports = __webpack_public_path__ + "static/img/11.4ed7551.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/2/2/sp/11.png
// module id = a0rr
// module chunks = 0